import { Link } from "react-router-dom";

export const NoData = () => (
  <div className="panel p-12 max-w-2xl" data-testid="no-data-state">
    <h2 className="font-serif text-3xl">No month-end data yet</h2>
    <p className="text-slate-600 mt-3">Upload spreadsheets for a month end first — entities, ownership and statements appear from there.</p>
    <Link to="/uploads" className="inline-block mt-6 bg-slate-900 text-white px-6 py-3 text-sm hover:bg-slate-800 transition-colors duration-200" data-testid="no-data-upload-link">Go to uploads</Link>
  </div>
);
